import React from 'react'
import {Button} from "antd";
import {consignmentCompleted, revertConsignmentCompleted} from "../../../services/serviceWarehouseOutgoing";

const OutgoingActions = ({consignmentStatus, recordId, updater}) => {

    const handleRevertClick = () => {
        revertConsignmentCompleted(recordId)
        updater()
    }
    const handleCompletedClick = () => {
        consignmentCompleted(recordId)
        updater()
    }

    return(
        <React.Fragment>
            <Button
                disabled={!consignmentStatus}
                type={"link"}
                onClick={handleCompletedClick}>
                Tamamlandı
            </Button>
            <Button
                disabled={consignmentStatus}
                danger
                onClick={handleRevertClick}>
                Geri Al
            </Button>
        </React.Fragment>
    )
}
export default OutgoingActions